import BreadCrumb from "components/common/BreadCrumb";
import { Card, CardBody, CardHeader, Container } from "reactstrap";
import { PaymentsTable } from "./PaymentsTable";
import PaymentSummaryWidgets from "./PaymentSummaryWidgets";
import { Link } from "react-router-dom";
import { getDocumentTitle } from "utils/helpers";
import { useAccess } from "features/Authentication/hooks/useAccess";
import { Permissions } from "features/RolesAndPermissions/constants/permission.constants";

const PaymentList = () => {
  document.title = getDocumentTitle("Payments");
  const { can } = useAccess();
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Payments" pageTitle="Finance" />
        <PaymentSummaryWidgets />
        <Card>
          <CardHeader className="d-flex justify-content-between">
            <h5 className="card-title mb-0">Payment List</h5>
            {can(Permissions.PAYMENT.CREATE) ? (
              <Link to="/finance/payments/create" className="btn btn-primary">
                <i className="ri-add-line align-bottom me-1"></i> New Payment
              </Link>
            ) : null}
          </CardHeader>
          <CardBody>
            <PaymentsTable />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default PaymentList;
